import { Typography } from '@/components/ui/typography'

interface DetailAboutSectionProps {
  description: string
}

export function DetailAboutSection({ description }: DetailAboutSectionProps) {
  return (
    <div id="about" className="scroll-mt-38 lg:scroll-mt-16">
      <Typography variant="h2" className="mb-2 md:mb-6">
        Více o místě
      </Typography>
      <div>
        {description.split('\n').map((item, key) => (
          <p key={key} className="mt-4 text-slate-700">
            {item}
          </p>
        ))}
      </div>
    </div>
  )
}
